import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AutomatedCustomFormComponent } from '../automated-custom-form/automated-custom-form.component';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-automated-form',
  templateUrl: './automated-form.component.html',
  styleUrls: ['./automated-form.component.scss']
})
export class AutomatedFormComponent {

  public data: any = {status: 1, type: 'referral-commission', trigger_time: 'daily', custom_commission: [], general_commission: [], daily_rolling_rate_only: 0};
  public rollingSetting: any = {
    agent_company_bucket_rate: '',
    agent_game_based_rolling_l1_rate: '',
    agent_game_based_rolling_l2_rate: '',
    agent_game_based_rolling_l3_rate: ''
  };
  private hasExistingGameBasedRollingSetting = false;
  private company_uuid:any;
  constructor(private modalService: NgbModal, private http: HttpService, private router: Router, private route: ActivatedRoute) { 
    this.company_uuid = this.http.getStaticSelectedCompany()
    this.getRollingSetting();
    this.route.params.subscribe(params => {
      if(params['uuid']) {
        this.getDetail(params['uuid']);
      }
    });
  }

  async getDetail(uuid: string) {
    let rtn:any = await this.http.post("/admin/automated/get", {uuid: uuid});
    this.data = rtn;
    this.data.general_commission = this.toArray(this.data.general_commission);
    this.data.custom_commission = this.toArray(this.data.custom_commission);
    this.data.daily_rolling_rate_only = this.isTruthy(this.data.daily_rolling_rate_only) ? 1 : 0;
    this.changeRuleType();
  }

  private toArray(value: any) {
    if (!value) {
      return [];
    }
    if (Array.isArray(value)) {
      return value;
    }
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  async getRollingSetting() {
    const setting: any = await this.http.post("/admin/setting/get");
    this.hasExistingGameBasedRollingSetting = this.isTruthy(setting.agent_game_based_rolling_enabled)
      || this.hasSettingValue(setting, 'agent_company_bucket_rate')
      || this.hasSettingValue(setting, 'agent_game_based_rolling_l1_rate')
      || this.hasSettingValue(setting, 'agent_game_based_rolling_l2_rate')
      || this.hasSettingValue(setting, 'agent_game_based_rolling_l3_rate');

    if (!this.hasExistingGameBasedRollingSetting) {
      return;
    }

    this.rollingSetting = {
      ...this.rollingSetting,
      ...setting
    };
    this.rollingSetting.agent_company_bucket_rate = this.defaultNumber(this.rollingSetting.agent_company_bucket_rate, 0.30);
    this.rollingSetting.agent_game_based_rolling_l1_rate = this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l1_rate, 1);
    this.rollingSetting.agent_game_based_rolling_l2_rate = this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l2_rate, 0.30);
    this.rollingSetting.agent_game_based_rolling_l3_rate = this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l3_rate, 0.20);
  }

  private hasSettingValue(setting: any, key: string) {
    return Object.prototype.hasOwnProperty.call(setting || {}, key)
      && setting[key] !== null
      && setting[key] !== undefined
      && setting[key] !== '';
  }

  private isTruthy(value: any) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  private defaultNumber(value: any, fallback: number) {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  private hasRollingInput() {
    return this.hasSettingValue(this.rollingSetting, 'agent_company_bucket_rate')
      || this.hasSettingValue(this.rollingSetting, 'agent_game_based_rolling_l1_rate')
      || this.hasSettingValue(this.rollingSetting, 'agent_game_based_rolling_l2_rate')
      || this.hasSettingValue(this.rollingSetting, 'agent_game_based_rolling_l3_rate');
  }

  shouldShowGameBasedRollingRates() {
    return this.data.type === 'referral-commission' && this.isTruthy(this.data.daily_rolling_rate_only);
  }

  changeComissionLevel() {
    let commission_level = this.data.commission_level;
    
    this.data.general_commission = [];

    while(this.data.general_commission.length < commission_level) {
      this.data.general_commission.push(0);
    }

    if(!this.data.commissions) {
      this.data.commissions = [];
    }

    while(this.data.commissions.length < commission_level) {
      this.data.commissions.push({});
    }
    
  }

  changeRuleType() {
    if (this.data.type === 'agent-commission') {
      this.data.wallet_type = 'agent_wallet';
      this.data.daily_rolling_rate_only = 0;
      // Red Share ladder: agent commission is a company-wide per-LEVEL schedule
      // (Level-1 % = top agent, Level-2 % = their downline agents, ...). Keep any existing
      // level count; default to 3 levels for a new rule. A single level acts as the legacy
      // fallback rate.
      if (!this.data.commission_level || this.data.commission_level < 1) {
        this.data.commission_level = (this.data.general_commission && this.data.general_commission.length) || 3;
      }
      if (!this.data.general_commission || this.data.general_commission.length === 0) {
        this.data.general_commission = [];
        while (this.data.general_commission.length < this.data.commission_level) {
          this.data.general_commission.push(0);
        }
      }
      return;
    }

    if (!this.data.custom_commission) {
      this.data.custom_commission = [];
    }
  }

  async submit() {
    this.data.daily_rolling_rate_only = this.isTruthy(this.data.daily_rolling_rate_only) ? 1 : 0;

    if (this.shouldShowGameBasedRollingRates() && (this.hasExistingGameBasedRollingSetting || this.hasRollingInput())) {
      await this.http.post("/admin/setting/save", {
        agent_game_based_rolling_enabled: true,
        agent_company_bucket_rate: this.defaultNumber(this.rollingSetting.agent_company_bucket_rate, 0.30),
        agent_game_based_rolling_l1_rate: this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l1_rate, 1),
        agent_game_based_rolling_l2_rate: this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l2_rate, 0.30),
        agent_game_based_rolling_l3_rate: this.defaultNumber(this.rollingSetting.agent_game_based_rolling_l3_rate, 0.20)
      });
    }

    let rtn:any  = await this.http.post("/admin/automated/save", this.data)

    if(rtn.status) {
      this.router.navigate(['/lo', this.company_uuid ,'setting-automated']);
    }
  }

  trackByFunc = (index: number, value: string) => index;

  customCommission(index: number) {
    const modalRef = this.modalService.open(AutomatedCustomFormComponent);
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.data = this.data.custom_commission[index] || [];
    modalRef.componentInstance.closeEvent.subscribe((result) => {
      this.data.custom_commission[index] = result;
      modalRef.close();
    });
  }

}
